import { useEffect } from "react";
import { config, activeTheme } from "@/config/base";

/**
 * Hook to initialize document head with config values
 * Sets title, favicon, language, and direction from config
 */
export const useConfigInit = () => {
  useEffect(() => {
    // Set document title
    document.title = `${config.appConfig.texts.appTitle} | ${config.appConfig.texts.organizationName}`;

    // Set favicon
    const faviconLink = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
    if (faviconLink) {
      faviconLink.href = config.appConfig.images.TabLogo;
    }

    // Set html element attributes
    const htmlElement = document.documentElement;
    htmlElement.lang = "fa"; // Persian language
    htmlElement.dir = "rtl"; // Right-to-left direction

    // Set html attributes for the theme from config
    htmlElement.setAttribute("data-theme", activeTheme);
  }, []);
};
